import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputControl, Label } from '@awaze/design-system.components.input';
import { Select } from '@awaze/design-system.components.select';
/**
 * A form component to select the flexibility around the start date of a holiday
 * */
export const FlexibilityInput = ({ formHooks, labels = {
    rangeLabel: 'Flexibility',
    rangeValidationMsg: 'Please select how much flexibilty in dates you wish to have',
}, flexibility: { options: flexibilityOptions }, isRequired = false, }) => (_jsxs(InputControl, { children: [_jsx(Label, { htmlFor: "range", children: labels.rangeLabel }), _jsx(Select, { name: "range", formHooks: formHooks, isRequired: isRequired, options: flexibilityOptions, validation: isRequired
                ? {
                    required: labels.rangeValidationMsg,
                }
                : {} })] }));
//# sourceMappingURL=flexibility-input.js.map